import React from 'react';

import { onboardColors } from '../../theme/onboardTokens';
import { usePortalCompact } from '../usePortalCompact';

import type { PropsWithChildren } from 'react';

interface Props {
  // `message` is the centred confirmation/expired card; `form` leaves room for the fixed footer.
  variant?: 'form' | 'message';
}

const PADDING = {
  form: { regular: '24px 40px 80px', compact: '20px 16px 80px' },
  message: { regular: '80px 40px', compact: '48px 20px' }
};

/** White content card used by every portal screen except the home page sections. */
const PortalCard: React.FC<PropsWithChildren<Props>> = ({ children, variant = 'form' }) => {
  const compact = usePortalCompact();

  return (
    <div
      style={{
        background: onboardColors.surface.white,
        borderRadius: compact ? 20 : 32,
        padding: PADDING[variant][compact ? 'compact' : 'regular'],
        textAlign: variant === 'message' ? 'center' : undefined
      }}
    >
      {children}
    </div>
  );
};

export default PortalCard;
